module.exports = __webpack_public_path__ + "img/sbatresultstable.33d11b85.png";